import useGenres from "@/hooks/useGenres";

// "All AI Films" + one chip per admin-managed AI Film sub-genre.
export default function SubGenreChips({ value, onChange, testPrefix = "subgenre" }) {
  const { ai_subgenres: subs } = useGenres();
  const chip = (active) => `shrink-0 px-3.5 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
    active ? "bg-sky-500 border-sky-500 text-white" : "bg-surface border-white/10 text-foreground/70 hover:text-foreground hover:border-white/25"}`;
  return (
    <div className="flex gap-2 overflow-x-auto hide-scrollbar pb-1" data-testid={`${testPrefix}-row`}>
      <button type="button" onClick={() => onChange(null)} className={chip(!value)} data-testid={`${testPrefix}-all`}>All AI Films</button>
      {subs.map((s) => (
        <button key={s} type="button" onClick={() => onChange(s)} className={chip(value === s)} data-testid={`${testPrefix}-${s.toLowerCase()}`}>
          {s}
        </button>
      ))}
    </div>
  );
}
